import { getUiVersionMonitor } from "../../../../../shared/frontend/system/uiVersionCheck";
import { isPublicWidgetPage } from "./utils/publicWidgetRoute";

const monitor = getUiVersionMonitor({ productKey: "m1member", uiBuildHeader: "X-M1member-Ui-Build" });
export const getBundledUiBuild = monitor.getBundledUiBuild;
export const fetchVersionJsonBuild = monitor.fetchVersionJsonBuild;
// Auch Antworten anonymer Formulare dürfen keinen Verwaltungs-Versionswechsel auslösen.
export function runVersionCheck(serverUiBuildHeader?: string | null): void {
  if (!isPublicWidgetPage()) monitor.runVersionCheck(serverUiBuildHeader);
}
export function registerVersionCheck(): void {
  if (!isPublicWidgetPage()) monitor.registerVersionCheck();
}
